import api from "./api";

// AS-IS / TO-BE redesign scenarios (FBPM Ch.8) — Before/After Devil's Quadrangle.

/** List a process's redesign scenarios (AS-IS + TO-BE) with deltas + heuristics. */
export async function getRedesignScenarios(processId) {
  return api.get(`/process/${processId}/redesign-scenarios`);
}

/**
 * Create a scenario. `payload.kind` = "AS_IS" | "TO_BE".
 * AS_IS with no metrics snapshots the live flow analysis.
 */
export async function createRedesignScenario(processId, payload) {
  return api.post(`/process/${processId}/redesign-scenarios`, payload);
}

/** Update a scenario's metrics / quality-flexibility scores / name. */
export async function updateRedesignScenario(scenarioId, payload) {
  return api.patch(`/redesign-scenarios/${scenarioId}`, payload);
}

/** Delete a scenario. */
export async function deleteRedesignScenario(scenarioId) {
  return api.delete(`/redesign-scenarios/${scenarioId}`);
}

/** Apply a catalog heuristic to a scenario. `payload` = { heuristicId, targetTaskId?, note? }. */
export async function applyHeuristic(scenarioId, payload) {
  return api.post(`/redesign-scenarios/${scenarioId}/heuristics`, payload);
}

/** Remove an applied heuristic from a scenario. */
export async function removeAppliedHeuristic(scenarioId, linkId) {
  return api.delete(`/redesign-scenarios/${scenarioId}/heuristics/${linkId}`);
}
